var _defs, _rect, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".success-a{fill:rgba(0,0,0,0);}.success-b{fill:#fff;opacity:0.3;}.success-c{fill:#00a344;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "success-a",
    width: 70,
    height: 70
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "success-b",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(5 5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "success-c",
    d: "M32.5,65A32.5,32.5,0,1,1,65,32.5,32.537,32.537,0,0,1,32.5,65Zm.032-58.5a26,26,0,1,0,26,26A26.03,26.03,0,0,0,32.532,6.5ZM31.318,44.443l0,0-4.83-4.347,0,0,.015-.013-6-5.4,4.349-4.832,6,5.4L42.468,22.336,47.3,26.688,31.32,44.44Z",
    transform: "translate(2 2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.683ecbde70509289acaa8c3b6d741934.svg";
export { ForwardRef as ReactComponent };